


















































import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class QrComponent extends Vue {
  @Prop() showMess?: boolean
  @Prop() linkGroup!: string
  @Prop() isLoading!: boolean
}
